import { reducerFactory } from '@ackee/jerome';
import { languages } from '../config';

export default reducerFactory(languages);
